import React from "react";
import Section from "evcharging/containers/layout/Section";
import Container from "evcharging/components/Container";
import Title from "evcharging/components/Title";
import Spacer from "evcharging/components/Spacer";
import Paragraph from "evcharging/components/Paragraph";
import Box from "evcharging/components/Box";
import InputError from "evcharging/components/InputError";
import Input from "evcharging/components/Input";
import useInput from "evcharging/hooks/useInput";
import { oneWord } from "evcharging/app/validation/filters";
import useFormResponse from "evcharging/hooks/useFormResponse";
import ResponsePopup from "evcharging/components/ResponsePopup";
import Form from "evcharging/components/Form";
import Loader from "evcharging/components/Loader";
import Button from "evcharging/components/Button";
import InlineGap from "evcharging/components/InlineGap";
import sendStayUpdated from "evcharging/app/client/sendStayUpdated";
import useI18n from "evcharging/hooks/useI18n";

const StayUpdated = () => {
  const { t } = useI18n();

  const email = useInput([oneWord]);

  const { isLoading, onSubmit, ...popup } = useFormResponse(
    { email },
    async (values: Record<string, string>) => {
      await sendStayUpdated(values);
    }
  );

  return (
    <>
      <Section background={'middle'} padding={'74px 0'}>
        <Container>
          <Title variant={'p'} center>
            {t('rates.stay-updated')}
          </Title>
          <Spacer value={16} />
          <Box maxWidth={550} margin={'0 auto'}>
            <Paragraph color={'middle'} textAlign={'center'}>
              {t('rates.keep-an-eye')}
            </Paragraph>
          </Box>
          <Spacer value={36} />
          <Form onSubmit={onSubmit}>
            <ResponsePopup {...popup} />
            <Box display={'flex'} justifyContent={'center'}>
              <Box maxWidth={344} width={'100%'}>
                <Input
                  required
                  placeholder={t('form.placeholder.email')}
                  name={'email'}
                  onChangeValue={email.onChangeValue}
                  value={email.value}
                  onBlur={() => email.setError('')}
                  invalid={!!email.error}
                  noSpace
                >
                  <InputError message={email.error} />
                </Input>
              </Box>
              <InlineGap desktop={12} />
              <Button type="submit" disabled={isLoading} height={56}>
                {isLoading ? <Loader /> : t('action.send')}
              </Button>
            </Box>
          </Form>
        </Container>
      </Section>
    </>
  );
};

export default StayUpdated;
